import React from "react";

import ConfirmModal from "components/common/modals/confirmModal/ConfirmModal";
import { convertArrayToCommaSeparatedString } from "utils/string";

/**
 * "Unsaved Changes" prompt: Keep Editing stays, Discard & Leave leaves.
 * `changes`: names of the unsaved changes, e.g. ["Clinic Notes"].
 */
const UnsavedChangesModal = ({ changes, onCancel, onConfirm }) => (
  <ConfirmModal
    title="Unsaved Changes"
    cancelText="Keep Editing"
    cancelButtonProps={{ color: "secondary" }}
    onCancel={onCancel}
    confirmText="Discard & Leave"
    confirmButtonProps={{ variant: "outlined", color: "error" }}
    onConfirm={onConfirm}
    style={{
      "& .MuiDialogContent-root": {
        padding: "16px 24px 0",
        paddingTop: "16px !important",
      },
      "& .MuiDialogActions-root": { padding: "16px 8px" },
    }}
    children={
      <span>
        {`You've made changes in ${convertArrayToCommaSeparatedString(changes)} that haven't been saved yet. Save them before you leave, or they will be lost.`}
      </span>
    }
  />
);

export default UnsavedChangesModal;
